import React from "react";
import {format} from "date-fns";
import {DateRangePicker} from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendarDays} from "@fortawesome/free-solid-svg-icons";
import PayoutSourceToggle from "./PayoutSourceToggle";
import "./Payouts.css";

function PayoutToolbar({
    source,
    onSourceChange,
    disabled = false,
    range,
    setRange,
    open,
    setOpen,
    pickerRef,
    onExport,
    exportDisabled = false,
}) {
    return (
        <div className="payout-toolbar">
            <PayoutSourceToggle
                source={source}
                disabled={disabled}
                onChange={onSourceChange}
            />
            <div className="payout-toolbar__right" ref={pickerRef}>
                <div className="inputImage payout-date-input">
                    <input
                        value={`${format(range[0].startDate, "dd/MM/yyyy")} - ${format(
                            range[0].endDate,
                            "dd/MM/yyyy"
                        )}`}
                        className="inputElement"
                        readOnly
                        onClick={() => setOpen((prev) => !prev)}
                    />
                    <FontAwesomeIcon
                        icon={faCalendarDays}
                        className="Calendericon"
                        onClick={() => setOpen((prev) => !prev)}
                    />
                </div>
                <div className="exportButton payout-export-btn">
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={onExport}
                        disabled={exportDisabled}
                    >
                        Export to CSV !!
                    </button>
                </div>
                {open && (
                    <div className="daterangepickerdiv payout-daterange-popup">
                        <DateRangePicker
                            onChange={(item) => setRange([item.selection])}
                            editableDateInputs={true}
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            months={2}
                            ranges={range}
                            direction="horizontal"
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default PayoutToolbar;
